import { forwardRef } from 'react'
import { Link } from 'react-router-dom'

export const RouterLink = forwardRef(({ to, ...other }, ref) => (
  <Link ref={ref} to={to} {...other} />
))

RouterLink.displayName = 'RouterLink'
